import { userService } from "../service";

function Profile() {
  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <h5>My Profile</h5>
      </div>
      <div className="mt-3">
        <div className="card border rounded-border-sm p-2">
          <div className="flex-nowrap p-2">
            <div className="fc-6">
              <p className="f-600">Username</p>
            </div>
            <div className="fc-6">{userService.userData.name}</div>
          </div>
          <div className="flex-nowrap p-2">
            <div className="fc-6">
              <p className="f-600">UserID</p>
            </div>
            <div className="fc-6">{userService.userData.userid}</div>
          </div>
          <div className="flex-nowrap p-2">
            <div className="fc-6">
              <p className="f-600">Mobile</p>
            </div>
            <div className="fc-6">{userService.userData.mobile}</div>
          </div>
          <div className="flex-nowrap p-2">
            <div className="fc-6">
              <p className="f-600">Email</p>
            </div>
            <div className="fc-6">{userService.userData.email}</div>
          </div>
          <div className="flex-nowrap p-2">
            <div className="fc-6">
              <p className="f-600">Merchant ID</p>
            </div>
            <div className="fc-6">{userService.userData.mercid}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
